const ACTIONS = {
  SELECT_EVENTS: 'SELECT_EVENTS',
  RESET_SELECTED: 'RESET_SELECTED'
};

export default ACTIONS;
